import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from './loader-service';

@Injectable()
export class HttpInterceptors implements HttpInterceptor {

    constructor(private loaderService: LoaderService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.requestStarted();
        return this.handler(next, req);
    }

    handler(next, request) {
        return next.handle(request).
            pipe(
                tap(
                    (event) => {
                        if (event instanceof HttpResponse) {
                            this.loaderService.requestEnded();
                        }
                    },
                    (error: HttpErrorResponse) => {
                        this.loaderService.resetSpinner();
                        throw error;
                    }
                )
            )
    }

}